import * as React from "react";

interface CourseContextInterface {
  course: any;
  updateCourse: (course: any) => void;
}
const CourseContext = React.createContext<CourseContextInterface | null>(null);
export default CourseContext;
export const useCourseValue = () => React.useContext(CourseContext);
